import {
  EvidenceGenerators,
  ListConnectedEvidenceGeneratorsRequest,
} from '@trustero/trustero-api-web/lib/attachment/attachment_pb'
import { AttachmentPromiseClient } from '@trustero/trustero-api-web/lib/attachment/attachment_grpc_web_pb'
import {
  Identifier,
  MODEL_TYPE,
} from '@trustero/trustero-api-web/lib/common/model_pb'
import { GrpcResponse, NewGrpcResponse } from '../hooks/types'
import { useSwrImmutableGrpc } from '../useSwrImmutableGrpc'

export const useEvidenceGenerators = ({
  modelType,
  connected,
  modelId,
  shouldFetch = true,
}: {
  modelType: MODEL_TYPE
  connected?: boolean
  modelId?: string
  shouldFetch?: boolean
}): GrpcResponse<EvidenceGenerators> => {
  const identifier = new Identifier().setModeltype(modelType)
  modelId && identifier.setModelid(modelId)
  const request = new ListConnectedEvidenceGeneratorsRequest().setIdentifier(
    identifier,
  )
  connected !== undefined && request.setConnected(connected)

  const { response } = useSwrImmutableGrpc(
    AttachmentPromiseClient.prototype.listConnectedEvidenceGenerators,
    request,
    shouldFetch,
  )
  return NewGrpcResponse(response)
}
